export function padNumber(x: number, n: number) {
  return (new Array(n).join('0') + x).slice(-n);
}

// 객체 배열을 받고, 그룹화할 객체의 키를 문자열로 받습니다.
// 반환 타입은 문자열 키에 매핑되는 객체 배열의 레코드입니다.
export function groupBy<T>(data: T[], key: keyof T): Record<string, T[]> {
  return data.reduce((acc: Record<string, T[]>, obj: T) => {
    const property = obj[key] as string;
    acc[property] = acc[property] || [];
    acc[property].push(obj);
    return acc;
  }, {});
}

/**
 * 문자열이 JSON 형식인지 확인합니다.
 */
export const isJsonString = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const buildQueryParams = (params: Record<string, string | number | undefined>): string => {
  return Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== '' && value !== 0)
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
    .join('&');
};
